import axiosInstance from '../configs/axios/interceptors';

const UsersServices = {

    getUsers: async (filters) => {    
        const response = await axiosInstance.get('User/GetUsersList',  {params: filters});
        return response.data;
    },


    createUser: async (payload) => {   
        const response = await axiosInstance.post('User/AddUser', payload);
        return response.data;
    },

    updateUser: async (payload) => {   
        const response = await axiosInstance.put('User/UpdateUser', payload);
        return response.data;
    },

    getRoles: async (roleName) => {      
        const params = { roleName: roleName};
        const response = await axiosInstance.get('User/GetRoles', {params: params});
        return response.data;
    },

  resetUserPassword: async (payload) => {   
        const response = await axiosInstance.put('User/ResetUserPassword', payload);
        return response.data;
    },

};

export default UsersServices;
